import { api } from "@/api/cliente"

/**
 * Una entrada del menú del personal, tal como la manda `GET /menu`: sólo las activas
 * para las que quien pregunta tiene permiso, ya ordenadas.
 */
export interface EntradaMenu {
  id: number
  clave: string
  etiqueta: string
  ruta: string
  icono: string
  seccion: string
}

/**
 * La consulta del menú, compartida por la barra lateral y el buscador de módulos
 * (05/11). ⚠ **La MISMA clave en los dos**: comparten caché y una sola petición, y lo
 * que el buscador ofrece es exactamente lo que el menú enseña.
 */
export const CONSULTA_MENU = {
  queryKey: ["menu"],
  queryFn: () => api.get<EntradaMenu[]>("/api/v1/menu"),
  // El menú cambia cuando alguien lo edita en la pantalla de accesos, no entre dos
  // clics. Sin esto, cada navegación volvería a pedirlo.
  staleTime: 5 * 60_000,
} as const
